import Model from "../Model";

export default class Product extends Model {
  name() {
    return Model.attribute<string>('name').call(this);
  }
  status() {
    return Model.attribute<number>('status').call(this);
  }

  createdAt() {
    return Model.attribute<Date | undefined, string | undefined>('createdAt', Model.transformDate).call(this);
  }
  updatedAt() {
    return Model.attribute<Date | undefined, string | undefined>('updatedAt', Model.transformDate).call(this);
  }
}
